// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"beb5ce9c","511":"8cddbf72","559":"00815264","787":"3e1d09d1","890":"3a5ab297"}[chunkId] + ".chunk.js";
};